const GoldenAge = (props) => {
    return (
        <div className='goldenAge' style={{"--mask-step": props.goldenAgeLevel}}>
            <img className={`absolute ${props.widthHeight}`} src="/GoldenAge/golden_age_icon.png"/>
            <div className={`absolute ${props.textClass} ${props.widthHeight}`}>
                <h1 className={``}>{props.goldenAgeLevel}</h1>
            </div>
        </div>
    )    
}

export { GoldenAge };